export enum PaymentType {
    PayPerUser,
    FlatFee
}